<template>
  <div class="notificationComp">
    <div class="notificationComp__head">
          <h1 class="mobiTitle md">{{ $t("notification") }}</h1>
    </div>
    <ul>
      <li  v-for="item in notification_fplus" :key="item.key">
        <router-link :to="{name: 'DetailPage',params: { id: item.id }}" class="notificationComp__wrap" >
          <div class="notificationComp__img">
              <img :src="item.thumbnail_url"/>
          </div>
          <div class="notificationComp__content">
            <h2 class="mobiTitle sm">{{item.content_name}}</h2>
            <p class="mobilabel">{{ item[`titleSub_${lang_fplus}`] }}</p>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["notification_fplus", "lang_fplus", "country_fplus"])
  },
  created() {
    this.fetchNotification_fplus();
  },
  methods: {
    ...mapActions(["fetchNotification_fplus"])
  }
};
</script>

<style scoped lang="scss">
.notificationComp {
  background: #23004d;
  box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
  padding: 15px;
  .mobiTitle {
    color: #fff;
  }
  .mobilabel {
    color: #23004d;
  }
  ul {
    list-style: none;
    padding: 0;
  }

  a {
    display: flex;
    color: #fff;
    text-decoration: none;
    padding: 10px;
    margin: 15px 0px;
    background: #7431d3;
    border-radius: 12px;
    min-width: 280px;
  }
  img {
    width: 100%;
  }
}
.notificationComp__head {
  padding: 8px 15px;
}
.notificationComp__content {
  padding-left: 8px;
}
.notificationComp__img {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  overflow: hidden;
}
.ar_layout {
  .notificationComp__content {
    padding-left: 0;
    padding-right: 8px;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/funplus/Notification.vue